import clsx from "clsx";
import { useId } from "react";

type TextFieldProps = Omit<
  React.ComponentPropsWithoutRef<"input">,
  "id" | "className"
> & {
  label: string;
  helperText?: string;
  error?: string;
};

export function TextField({
  label,
  helperText,
  error,
  type = "text",
  ...props
}: TextFieldProps) {
  const id = useId();
  const messageId = useId();

  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={id}
        className="font-sans text-sm font-bold text-butter-green leading-[1.4]"
      >
        {label}
      </label>
      <input
        id={id}
        type={type}
        aria-invalid={error ? true : undefined}
        aria-describedby={error || helperText ? messageId : undefined}
        className={clsx(
          "block w-full rounded-[9px] border bg-white px-3 py-3 font-sans text-base text-butter-green outline-none transition-colors",
          "placeholder:text-placeholder-text",
          error
            ? "border-butter-pink focus:border-butter-pink"
            : "border-butter-cream focus:border-butter-green/60",
        )}
        {...props}
      />
      {error ? (
        <p
          id={messageId}
          role="alert"
          className="font-sans text-sm text-butter-pink leading-[1.4]"
        >
          {error}
        </p>
      ) : helperText ? (
        <p
          id={messageId}
          className="font-sans text-sm text-butter-green/70 leading-[1.4]"
        >
          {helperText}
        </p>
      ) : null}
    </div>
  );
}
